import type { PaymentProcessor } from "@/react/types/CurrentCommunity";
import { Header } from "./Header";
import { List } from "./List";
import { PaymentProcessorEnabled } from "./PaymentProcessorStatus/PaymentProcessorEnabled";
import { PaymentProcessorNotExist } from "./PaymentProcessorStatus/PaymentProcessorNotExist";
import { PaymentProcessorRestricted } from "./PaymentProcessorStatus/PaymentProcessorRestricted";
import { PaymentProcessorRestrictedFeesToApply } from "./PaymentProcessorStatus/PaymentProcessorRestrictedFeesToApply";
import { PaymentProcessorWithStatus } from "./PaymentProcessorStatus/PaymentProcessorWithStatus";
import { PaymentProcessorStatus } from "./constants";
import { usePaywallsAdmin } from "./hooks/usePaywallsAdmin";

interface PaywallsComponentProps {
  paymentProcessor: PaymentProcessor;
  shouldHideHeader?: boolean;
}

const renderPaymentProcessorRejected = () => (
  <PaymentProcessorWithStatus status="rejected" />
);

const renderPaymentProcessorPending = () => (
  <PaymentProcessorWithStatus status="pending" />
);

const getPaymentProcessorStatusComponent = (
  status: (typeof PaymentProcessorStatus)[keyof typeof PaymentProcessorStatus],
  paymentProcessor: PaymentProcessor,
) => {
  switch (status) {
    case PaymentProcessorStatus.REJECTED:
      return renderPaymentProcessorRejected();
    case PaymentProcessorStatus.PENDING:
      return renderPaymentProcessorPending();
    case PaymentProcessorStatus.RESTRICTED_FOR_APPLICATION_FEES:
      return <PaymentProcessorRestrictedFeesToApply />;
    case PaymentProcessorStatus.RESTRICTED:
      return <PaymentProcessorRestricted />;
    case PaymentProcessorStatus.ENABLED:
      return <PaymentProcessorEnabled paymentProcessor={paymentProcessor} />;
    case PaymentProcessorStatus.NOT_EXIST:
      return <PaymentProcessorNotExist />;
    default:
      return null;
  }
};

export const PaywallsComponent = ({
  paymentProcessor,
  shouldHideHeader = false,
}: PaywallsComponentProps) => {
  const {
    paymentProcessorStatus,
    paywalls,
    refetchPaywalls,
    isPaywallsLoading,
  } = usePaywallsAdmin({ paymentProcessor });

  const renderPaymentProcessorStatus = getPaymentProcessorStatusComponent(
    paymentProcessorStatus,
    paymentProcessor,
  );

  return (
    <>
      {!shouldHideHeader && (
        <Header
          paymentProcessorStatus={paymentProcessorStatus}
          refetchPaywalls={refetchPaywalls}
        />
      )}
      {renderPaymentProcessorStatus}
      {paymentProcessorStatus === PaymentProcessorStatus.ENABLED && (
        <List
          isPaywallsLoading={isPaywallsLoading}
          paywalls={paywalls ?? []}
          refetchPaywalls={refetchPaywalls}
        />
      )}
    </>
  );
};
